import _ from 'lodash';
import * as AllApis from '../store/services/apiConstants';
import Network from './api';

const Success = 'Success';
const Failure = 'Failure';

const networkCall = data => dispatch => {
	let action = data.action;
	let apiObject = AllApis[action];

	if (!apiObject) {
		return new Promise((resolve, reject) => {
			resolve({
				success: false,
				data: 'Action not found',
			});
		});
	}

	return Network(apiObject, data.data)
		.then(resp => {
			console.log('--- Response --- ' + JSON.stringify(resp));
			if (resp.status && resp.status === 200) {
				try {
					console.log('-- Action Dispatch -- ' + action + Success);
					dispatch({type: action + Success, payload: resp.data});				
				} catch (error) {
					console.log(error);
				}
				return {
					success: true,
					data: resp.data,
				};
			} else {
				try {
					console.log('Action Dispatch -- ' + action + Success);
					dispatch({type: action + Failure, payload: resp.data});
				} catch (error) {
					console.log(error);
				}
				return {
					success: false,
					data: resp,
				};
			}
		})
		.catch(err => {
			console.log('error2', err);
		});
};

const reducerCall = data => async dispatch => {
	dispatch({type: data.action, payload: data.data});
};

export default {
	networkCall,
	reducerCall,
};
